import React, { useState, useEffect } from "react";
import SubHead from "../SubHead";
import PopupPwdConfirm2 from "../../../component/PopupPwdConfirm2";

import { GetList } from "../../../lib/Board";
import moment from "moment";
import PagingView from "../../../component/PagingView";
import { Link } from "react-router-dom";

const List = props => {
    const [password, setPassword] = useState(sessionStorage.getItem("safety_pwd") === null ? "" : sessionStorage.getItem("safety_pwd"));
    const [years, setYears] = useState([]);
    const [items, setItems] = useState([]);
    const [data, setData] = useState({
        page: 1,
        size: 30,
        sort: "-id",
        board: "safety",
        title: "",
        year: ""
    });
    const [showPasswordPopup, setShowPasswordPopup] = useState(true);

    const [range, setRange] = useState({
        end: 0,
        size: 1,
        start: 0,
        total: 1
    });

    useEffect(() => {
        for (var i = moment().format("YYYY"); i >= 2021; i--) {
            years.push(i);
        }
        setYears(years);
    }, []);

    useEffect(() => {
        if (password !== "") {
            reloadList(1);
        }
    }, [password]);

    const reloadList = page => {
        data.page = page;
        data.password = password;
        setData(data);
        GetList(data, resultList, res => {
            alert("비밀번호가 맞지 않습니다.");
            setPassword("");
        });
    };

    /**
     * 리스트
     */
    const resultList = response => {
        sessionStorage.setItem("safety_pwd", password);
        setItems(response.rows);
        setRange(response.range);
        setShowPasswordPopup(false);
    };

    return (
        <>
            <SubHead title="안전보건" eng="SAFETY"></SubHead>
            <main className="sub-contents">
                <div className="inner">
                    <form className="search-form">
                        <label>검색</label>
                        <select
                            value={data.year}
                            onChange={e => {
                                data.year = e.target.value;
                                setData({ ...data });
                            }}
                        >
                            <option key={""}>년도별</option>
                            {years.map(x => (
                                <option key={x}>{x}</option>
                            ))}
                        </select>
                        <input
                            type="text"
                            placeholder="검색어를 입력하세요"
                            value={data.title}
                            onChange={e => {
                                data.title = e.target.value;
                                setData({ ...data });
                            }}
                        />
                        <button
                            type="button"
                            onClick={() => {
                                reloadList(1);
                            }}
                        >
                            검색
                        </button>
                    </form>

                    <div className="board-list-top">
                        <p className="total">
                            Total {range.total}건 {Math.ceil(Number(range.total) / Number(range.size))}페이지
                        </p>
                    </div>

                    <div className="board-list-wrap">
                        <table className="board-list">
                            <colgroup>
                                <col width="10%" />
                                <col width="auto" />
                                <col width="10%" />
                                {/* <col width="10%" />
                                <col width="10%" /> */}
                                <col width="10%" />
                            </colgroup>
                            <thead>
                                <th>NO</th>
                                <th>내용</th>
                                <th>파일</th>
                                {/* <th>작성자</th>
                                <th>조회수</th> */}
                                <th>공지일</th>
                            </thead>
                            <tbody>
                                {items.map(x => {
                                    return (
                                        <tr>
                                            <td>{x.id}</td>
                                            <td className="textL">
                                                <Link to={`/promotion/board_safety/info/${data.board}/${x.id}`}>
                                                    <a href="#" className="link">
                                                        <span className="sbj">{x.title}</span>
                                                        {x.public === "N" && <span className="icons-lock"></span>}
                                                    </a>
                                                </Link>
                                            </td>
                                            <td>{x.files.length > 0 && <span className="icons-file"></span>}</td>
                                            {/* <td>{x.name}</td>
                                            <td>{x.show}</td> */}
                                            <td>{moment(x.createdAt).format("YYYY.MM.DD")}</td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>

                    {/* <div className="board-btns">
                        <button type="button" className="btn_nor red-line">
                            글쓰기
                        </button>
                    </div> */}

                    <PagingView nowPage={Number(data.page)} totalPage={Math.ceil(Number(range.total) / Number(range.size))} reload={reloadList} />
                </div>
            </main>

            {/* 비밀글 클릭 시 나타나는 팝업 - 클래스 on 추가 시 표현 */}
            <PopupPwdConfirm2
                show={password === "" && showPasswordPopup}
                onClose={e => {
                    setShowPasswordPopup(false);
                }}
                onConfirm={pwd => {
                    setPassword(pwd);
                }}
            />
        </>
    );
};

export default List;
